import { AssetInterface } from "@/interfaces/asset.interface";
import { ref } from "@vue/composition-api";
import axios from "@/libs/axios";

const assets = ref(new Map<number, AssetInterface>());

export default function useAssets() {
    const retrieveAsset = (id: number, refetch?: boolean) => {
        if (!refetch && assets.value.has(id)) {
            return;
        }
        axios.get<AssetInterface>(`assets/${id}`).then((response) => {
            assets.value = new Map(assets.value.set(id, response.data));
        });
    };

    const setAsset = (id: number, asset: AssetInterface) => (assets.value = new Map(assets.value.set(id, asset)));

    const getAsset = (id: number | undefined): AssetInterface | undefined => (id ? assets.value.get(id) : undefined);

    return {
        retrieveAsset,
        getAsset,
        setAsset,
    };
}
